//Libraries
import React from 'react';
import { connect } from 'react-redux';
//Actions
import { getUserFullName } from '../../actions/utils';

class UserFullName extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      name: ''
    }
  }
  componentWillMount() {
    this.setState(() => {
      return ({name: this.props.getUserFullName(this.props.userUid)});
    })
  }
  render() {
    return (
      <div>
        {this.state.name}
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  getUserFullName: (userUid) => dispatch(getUserFullName(userUid))
});

export default connect(undefined, mapDispatchToProps)(UserFullName);
